import { render } from "./AvioMulag.vue?vue&type=template&id=da9d9f28&scoped=true"
import script from "./AvioMulag.vue?vue&type=script&lang=js"
export * from "./AvioMulag.vue?vue&type=script&lang=js"

import "./AvioMulag.vue?vue&type=style&index=0&id=da9d9f28&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da9d9f28"]])

export default __exports__